export const COMPARE_USER = 'COMPARE_USER'
export const COMPARE_USER_ERR = 'COMPARE_USER_ERR'

export const RESET_COMPARE_USER = 'RESET_COMPARE_USER'